<template>
  <edit></edit>
</template>

<script>
import edit from './app_version_edit.vue'
export default {
  name: 'app_version_add',

  components: {
    edit
  }
}
</script>